// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Berkshire+Swash&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/sansation);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
    font-size: 100px;
    margin-top: 40px;
}
.animate-gradient-text {
    background-image: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
    background-size: 200%;
    -webkit-text-fill-color: transparent;
    -webkit-background-clip: text;
    background-clip: text;
    animation: animated-gradient 5s ease infinite;
}
@keyframes animated-gradient {
    0%, 100% {
        background-position: 0 50%;
    }
    50% {
        background-position: 100% 50%;
    }
}
.main_box {
    width: 100%;
  
    font-family: 'Sansation';
    text-align: center;
    margin-top: 10px;
    top:200px;
    position: relative;

}
.upper_content {
    font-size: 30px;
    position: relative;
  padding: 0;   
  margin: 0;
  margin-top: 10px;
  /* overflow:auto; */
  top:200px;
  position: relative;
  

}
section {
    display: flex;
    flex-flow: row wrap;
    position: relative;
    top:200px;
}
section > div {
    flex: 1 1;
    padding: 0.5rem;
    /* flex-flow: column ; */
}
input[type="radio"] {
    display: none;
}
label {
    display: block;
    background: white;
    border: 2px solid hsla(150, 75%, 50%, 1);
    border-radius: 20px;
    padding: 1rem;
    text-align: center;
    box-shadow: 0px 3px 10px -2px hsla(150, 5%, 65%, 0.5);
    position: relative;
}
input[type="radio"]:checked + label {
    background: hsla(150, 75%, 50%, 1);
    color: white;
    box-shadow: 0px 0px 20px hsla(150, 100%, 50%, 0.75);
}
#submit_ocp {
    background: #9ffefe;
    border: none;
    font-family: 'Sansation';
    font-size: 25px;
    border-radius: 10px;
    width: 250px;
    height: 50px;
    position: relative;
    top:200px;
}
@media screen and (max-width: 500px) {
    .main_box {
        font-size: 20px;
    }
    .upper_content h1 {
        font-size: 40px;
    }
    .upper_content h2 {
        font-size: 30px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/OccupationAdder.css"],"names":[],"mappings":"AAGA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,6EAA6E;IAC7E,qBAAqB;IACrB,oCAAoC;IACpC,6BAA6B;IAC7B,qBAAqB;IACrB,6CAA6C;AACjD;AACA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,6BAA6B;IACjC;AACJ;AACA;IACI,WAAW;;IAEX,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;;AAEtB;AACA;IACI,eAAe;IACf,kBAAkB;EACpB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;;;AAGpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,SAAO;IACP,eAAe;IACf,wBAAwB;AAC5B;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,wCAAwC;IACxC,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,qDAAqD;IACrD,kBAAkB;AACtB;AACA;IACI,kCAAkC;IAClC,YAAY;IACZ,mDAAmD;AACvD;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,SAAS;AACb;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Berkshire+Swash&display=swap');\r\n@import url('https://fonts.cdnfonts.com/css/sansation');\r\n\r\nh1 {\r\n    font-size: 100px;\r\n    margin-top: 40px;\r\n}\r\n.animate-gradient-text {\r\n    background-image: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);\r\n    background-size: 200%;\r\n    -webkit-text-fill-color: transparent;\r\n    -webkit-background-clip: text;\r\n    background-clip: text;\r\n    animation: animated-gradient 5s ease infinite;\r\n}\r\n@keyframes animated-gradient {\r\n    0%, 100% {\r\n        background-position: 0 50%;\r\n    }\r\n    50% {\r\n        background-position: 100% 50%;\r\n    }\r\n}\r\n.main_box {\r\n    width: 100%;\r\n  \r\n    font-family: 'Sansation';\r\n    text-align: center;\r\n    margin-top: 10px;\r\n    top:200px;\r\n    position: relative;\r\n\r\n}\r\n.upper_content {\r\n    font-size: 30px;\r\n    position: relative;\r\n  padding: 0;   \r\n  margin: 0;\r\n  margin-top: 10px;\r\n  /* overflow:auto; */\r\n  top:200px;\r\n  position: relative;\r\n  \r\n\r\n}\r\nsection {\r\n    display: flex;\r\n    flex-flow: row wrap;\r\n    position: relative;\r\n    top:200px;\r\n}\r\nsection > div {\r\n    flex: 1;\r\n    padding: 0.5rem;\r\n    /* flex-flow: column ; */\r\n}\r\ninput[type=\"radio\"] {\r\n    display: none;\r\n}\r\nlabel {\r\n    display: block;\r\n    background: white;\r\n    border: 2px solid hsla(150, 75%, 50%, 1);\r\n    border-radius: 20px;\r\n    padding: 1rem;\r\n    text-align: center;\r\n    box-shadow: 0px 3px 10px -2px hsla(150, 5%, 65%, 0.5);\r\n    position: relative;\r\n}\r\ninput[type=\"radio\"]:checked + label {\r\n    background: hsla(150, 75%, 50%, 1);\r\n    color: white;\r\n    box-shadow: 0px 0px 20px hsla(150, 100%, 50%, 0.75);\r\n}\r\n#submit_ocp {\r\n    background: #9ffefe;\r\n    border: none;\r\n    font-family: 'Sansation';\r\n    font-size: 25px;\r\n    border-radius: 10px;\r\n    width: 250px;\r\n    height: 50px;\r\n    position: relative;\r\n    top:200px;\r\n}\r\n@media screen and (max-width: 500px) {\r\n    .main_box {\r\n        font-size: 20px;\r\n    }\r\n    .upper_content h1 {\r\n        font-size: 40px;\r\n    }\r\n    .upper_content h2 {\r\n        font-size: 30px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
